import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ProfilePage } from './pages/profile/profile.page';
import { SettingsPage } from './pages/settings/settings.page';
import { AuthGuardService } from './services/auth-guard.service';
import { AdminGuard } from './guards/admin.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'settings',
    component: SettingsPage,
    loadChildren: () => import('./pages/settings/settings.module').then( m => m.SettingsPageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'profile',
    component: ProfilePage,
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/prelogin/signup/signup.module').then( m => m.SignupPageModule)
  },
  {
    path: 'passwordreset',
    loadChildren: () => import('./pages/prelogin/passwordreset/passwordreset.module').then( m => m.PasswordresetPageModule)
  },
  {
    path: 'song-create',
    loadChildren: () => import('./pages/song-create/song-create.module').then( m => m.SongCreatePageModule)
  },
  {
    path: 'song-list',
    loadChildren: () => import('./pages/song-list/song-list.module').then( m => m.SongListPageModule)
  },
  {
    path: 'song-detail/:id',
    loadChildren: () => import('./pages/song-detail/song-detail.module').then( m => m.SongDetailPageModule)
  },
  {
    path: 'song-detail',
    loadChildren: () => import('./pages/song-detail/song-detail.module')
      .then(m => m.SongDetailPageModule)
  },
  {
    path: 'song-plans',
    loadChildren: () => import('./pages/song-plans/song-plans.module').then( m => m.SongPlansPageModule)
  },
  {
    path: 'checkout',
    loadChildren: () => import('./pages/checkout/checkout.module').then( m => m.CheckoutPageModule)
  },
  {
    path: 'payment-success',
    loadChildren: () => import('./pages/payment-success/payment-success.module').then( m => m.PaymentSuccessPageModule)
  },
  {
    path: 'profile-edit',
    loadChildren: () => import('./pages/profile-edit/profile-edit.module').then( m => m.ProfileEditPageModule)
  },
  {
    path: 'present/:id',
    loadChildren: () => import('./pages/present/present.module').then( m => m.PresentPageModule)
  },
  {
    path: 'analytics-dashboard',
    loadChildren: () => import('./pages/analytics-dashboard/analytics-dashboard.module').then( m => m.AnalyticsDashboardPageModule),
    canActivate: [AdminGuard],
  },
  { path: "**", redirectTo: "home" },












];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      // Path-Routing statt Hash. Braucht die Rewrite-Regel in src/.htaccess,
      // sonst geben Direktaufruf und Reload einer tiefen URL 404.
      // Alte Links in der Form /#/pfad faengt der Shim in index.html ab.
      // enableTracing: true // debug tracing
     })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
